import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { SignUpProps } from "./types";

export class SignUpDefinitions extends CmsReactComponent<SignUpProps> {
    static defaultProps = {};

    static schemaName = "sign-up";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "title",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Başlık",
    },
    {
        name: "description",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Açıklama",
    },
    {
        name: "membershipAgreement",
        mapping: {
            type: PropertyMappingType.Html,
        },
        text: "Üyelik Sözleşmesi",
    },
    {
        name: "approveCodeTitle",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Onay Kodu Başlık",
    },
    {
        name: "approveCodeDescription",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Onay Kodu Açıklama",
    },];
}
